import { render, staticRenderFns } from "./RouterTop.vue?vue&type=template&id=7be27150&scoped=true"
import script from "./RouterTop.vue?vue&type=script&lang=js"
export * from "./RouterTop.vue?vue&type=script&lang=js"
import style0 from "./RouterTop.vue?vue&type=style&index=0&id=7be27150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be27150",
  null
  
)

export default component.exports